import { combineReducers } from "redux";
import commonReducer from "@frameworks/web/redux/feature/Markets/Common/Reducers/commonReducer";
import EqSipOrderBookReducer from "./eqSipOrderBook";
export default combineReducers({
    reducersData: EqSipOrderBookReducer,
    commonData: commonReducer,
});
